import React, { useState, useEffect } from "react";
import * as ConfigTypes from 'config/ConfigTypes';
import { parseStringField, checkGroupFields, checkMapping } from "helpers/FieldHelper";
import { sliceText } from "helpers/FieldHelper";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import UIMultiCalendar from "components/UI/MultiCalendar/MultiCalendar";
import * as CartShare from "components/Cart/CartShare/CartShare";
import { changeDateFormat } from 'helpers/DateHelper';
import './ListItem.scss';

const ListItem = ({ showFields, item, curMode, configName, formatMessage,
    actions = null, onDateAction, onOtherActions, onListItemClick,
    isCart, isRentalList, cartObjects, onEditItem, onDeleteItem }) => {
    const [userInputs, setUserInputs] = useState({});

    const initData = () => {
        if (item.showdates && item.showdates.length) {
            const { itemsShowsObj } = cartObjects;
            let initObj = {};
            item.showdates.forEach((date, idx) => {
                if (itemsShowsObj[item.id] && itemsShowsObj[item.id][date]) {
                    initObj[date] = itemsShowsObj[item.id][date];
                } else initObj[date] = 1;
            });
            setUserInputs(initObj);
        }
    }

    useEffect(() => {
        initData();
    }, []);

    useEffect(() => {
        initData();
    }, [cartObjects.itemsDateObj[item.id]]);

    const handleChange = ({ e, el }) => {
        let updated = { ...userInputs, [el]: e.target.value };
        setUserInputs(updated);
        onEditItem({ item, userInputs: updated });
    }

    const onListItem = () => {
        onListItemClick(item);
    }

    const getListItemClasses = () => {
        if (isCart) return "listitem-cl-items-li";
        if (isRentalList) return "listitem-rl-items-li";
        if (configName === ConfigTypes.ITEM) return "listitem-wl-items-li";
        if (configName === ConfigTypes.WORK) return "listitem-wl-works-li";
        return "listitem-li";
    }

    const onCalendarClick = () => { }
    const onBtnChooseClick = () => { }
    const onBtnOkClick = () => { }

    const showCalendar = ({ el }) => {
        return (
            <div className="listitem-item listitem-action">
                <UIMultiCalendar formatMessage={formatMessage} onBtnChooseClick={onBtnChooseClick}
                    btnOkId="calendar.done" btnChooseId="calendar.choose"
                    isCartSymbol={el.isCartSymbol || false}
                    onDateAction={onDateAction} item={item} cartObjects={cartObjects}
                    onBtnOkClick={onBtnOkClick} onCalendarClick={onCalendarClick} />
            </div>
        )
    }

    const showActions = () => {
        return actions && actions.map(el => {
            if (el.type === ConfigTypes.CALENDAR) return showCalendar({ el });

            return (
                <div className="listitem-item listitem-action" onClick={() => onOtherActions({ item, action: el.action })} >
                    <div className={`listitem-action-box ${el.htmlClasses && el.htmlClasses}`}>
                        <FontAwesomeIcon icon={el.icon} />
                        {el.intl && formatMessage({ id: el.intl })}
                    </div>
                </div>)
        })
    }

    const showEditList = () => {
        if (item.showdates && item.showdates.length)
            return (
                <div className="listitem-showeditlist">
                    {item.showdates.map(el => (
                        <div className="listitem-showeditlist-li">
                            <span>{changeDateFormat({ date: new Date(el) })}</span>
                            <input type="number" min="0" value={userInputs[el]} onChange={(e) => handleChange({ e, el })} />
                            <FontAwesomeIcon icon={faTrash} onClick={() => onDeleteItem({ item, el, userInputs })} />
                        </div>
                    ))}
                </div>
            )

        return null;
    }

    const showComplex = ({ el, i }) => {
        return (
            <div className="listitem-complex">
                {CartShare.showComplexElement({
                    el, idx: i, obj: item, viewMode: curMode, fm: formatMessage
                })}
            </div>
        )
    }

    return (
        <>
            <li className={getListItemClasses()}>
                {showFields.map((el, i) => {
                    let subType = el[`${curMode}type`];
                    if (el.type === ConfigTypes.EDITLIST) return showEditList();
                    if (el.type === ConfigTypes.CALENDAR) return showCalendar({ el });
                    if (el.type == ConfigTypes.COMPLEX) return showComplex({ el, i });
                    let fieldTxt;
                    if (item && item.metadata && item.metadata.fields) {
                        fieldTxt = parseStringField(item.metadata.fields[el.field]);
                    }
                    if (!fieldTxt) fieldTxt = parseStringField(item[el.field]);
                    if (!fieldTxt) fieldTxt = parseStringField(item[el.name]);
                    fieldTxt = checkMapping({ el, fieldTxt });
                    let classes = " listitem-item";
                    if (el.htmlClasses) classes = `listitem-item ${el.htmlClasses}`
                    if (el.createStatus) {
                        let found = ConfigTypes.RENTAL_STATUS.find(item => item.value == fieldTxt)
                        if (found) classes = `listitem-item ${found.htmlClasses && found.htmlClasses}`
                    }

                    if (subType && subType == ConfigTypes.COMBINE) {
                        let groupFields = el[`${curMode}group`];
                        fieldTxt = groupFields.split(";").map(sub => item.item[sub]).join(" ");
                    }

                    return (<div key={`listitem${i}${el.field || ''}`} onClick={onListItem}
                        className={classes}>
                        {sliceText(fieldTxt, 40)}
                        {checkGroupFields({ isGroup: el[`${curMode}group`], el, element: item, viewMode: curMode })}
                    </div>)
                }
                )}
                {showActions()}
            </li>
        </>
    )
}

export default ListItem;